import styled from 'styled-components'
import colors from '@settings/styleSettings'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  align-items: center;
  padding-top: 8px;
  margin: 0 auto;
`
export const FilterContainer = styled.div`
  cursor: pointer;
  border-radius: 5px;
  flex-grow: 0;
  padding: 6px;
  background-color: ${colors.softGreen};
`
export const BoldText = styled.text`
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
`
export const SimpleText = styled.div`
  font-size: 16px;
`
export const Icon = styled.text`
  font-size: 5px;
`
export const Option = styled.text`
  font-size: 10px;
  display: flex;
  align-items: center;
  flex-grow: 0;
  justify-content: center;
  align-content: center;
`
export const Text = styled.div`
  display: flex;
  flex-grow: 0;
  align-items: center;
  justify-content: center;
  align-content: center;
`
export const Header = styled.div`
  display: flex;
  margin: 10px;
  width: 100%;
  height: auto;
  flex-grow: 0;
`
export const Select = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => (props.showmenu ? colors.softGreen : '')};
  margin: 15px;
  border-radius: 5px;
  padding-bottom: 4px;
`

export const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  border-bottom: 1pt solid ${colors.softGray};
  color: ${colors.strongGray};
  background-color: 'none';
  align-items: center;
  width: 100%;
  border-radius: 12px;
  padding: 16px;
  border: 1pt solid ${colors.softGray};
  margin: 10px 16px;
`
export const RowTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  width: 30%;
`
export const Title = styled.text`
  font-size: 16px;
  font-weight: bold;
  color: ${colors.titleStrongBlack};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`
export const CardIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${(props) => props.color[1]};
  color: ${(props) => props.color[0]};
  font-size: 16px;

  @media (max-width: 1200px) {
    display: none;
  }
`
export const Divisor = styled.div`
  width: 1px;
  height: 80%;
  background-color: ${colors.softGray};
`

export const TextName = styled.div`
  font-size: 16px;
  color: ${colors.strongGray};
  width: 30%;
  padding-left: 16px;
`
export const DescriptionText = styled.div`
  font-size: 16px;
  color: ${colors.strongGray};
  padding-left: 16px;
  width: 30%;
`
export const OriginCard = styled.div`
  margin-left: 16px;
  margin-right: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background-color: ${(props) => props.color[1]};
  color: ${(props) => props.color[0]};
  padding: 6px;
  font-size: 14px;
`
export const OriginText = styled.text`
  text-wrap: nowrap;
  text-align: center;
  font-size: 14px;
`
export const CardOption = styled.div`
  cursor: pointer;
  margin-left: 16px;
`
export const Date = styled.text`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  color: ${colors.strongGray};
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const SeeMore = styled.div`
  font-size: 16px;
  color: ${colors.mostStrongestGray};
  display: flex;
  justify-content: flex-end;
  width: 8%;
  align-items: center;
  align-content: center;
  cursor: pointer;
`
export const ArrowIcon = styled.text`
  color: ${colors.strongGray};

  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
`
